module.exports = __webpack_public_path__ + "static/media/update class discipline.f00b685c.svg";